<breadcrumb
  [paginas]="[
    { route: '/home', name: 'Home' },
    { route: '/registro-saida', name: 'Registro Saida ' },
    {
      route: '/registro-saida/jornada',
      name: 'Visualizar Jornada e Atividades ',
    },
  ]"
/>

<!-- TITULO -->
<section class="section-saudacao">
  <div class="container">
    <h2 class="titulo-page">Visualizar Atividades</h2>

    <app-btn-back class="btn_voltar_consulta"></app-btn-back>
  </div>
</section>

<section class="section-informacoes-psicologo">
  <div class="container">
    <p>
      <b>Atividades Referente</b>
    </p>
    <p class="icon-paragraph">
      <i class="fa-solid fa-user" aria-hidden="true"></i>Psicólogo(a):
      {{ jornada?.nomePsicologo }} - {{ jornada?.cpfPsicologo }}
    </p>
    <p class="icon-paragraph">
      <img
        src="../../../assets/img/icons/icon-nome-escola.svg"
        title="Diretoria de Ensino"
        alt=""
      />
      <b>URE: </b> {{ jornada?.nomeDiretoria }}
    </p>
    <p class="icon-paragraph">
      <img
        src="../../../assets/img/icons/icon-nome-escola.svg"
        title="Diretoria de Ensino"
        alt=""
      />
      <b>Escola: </b> {{ jornada?.nomeEscola }}
    </p>
    <p class="horas-trabalhadas">
      Total de horas trabalhadas:<b>{{
        totalHorasTrabalhadas | date: "HH:mm"
      }}</b>
    </p>
  </div>
</section>

<section class="section-grid-consulta-ponto">
  <div class="container">
    <div class="row_registros">
      <h3>Listagem de Atividades realizadas</h3>
    </div>

    <div class="conteudo-atividades">
      @for (atividade of jornada?.atividades; track atividade.codigoAtividade) {
        <details [open]="atividade?.codigoAtividade == atividadeId">
          <summary>
            <span class="historico-label">{{ atividade.titulo }}</span>
            <span class="log-details"
              >Data: {{ atividade.dataAtividade | date: "dd/MM/yyyy" }} Tipo
              Atividade: {{ getTipoAtividade(atividade.tipoAtividade) }}</span
            >
          </summary>
          <div class="conteudo-detalhes-acordion">
            <div class="row-tres-colunas">
              <div class="col">
                <p><b>Data da visita à URE/Escola:</b></p>
                <p>{{ atividade.dataAtividade | date: "dd/MM/yyyy" }}</p>
                <!-- <p>01/07/2024</p> -->
              </div>
              <div class="col">
                <p><b>Data do Registro:</b></p>
                <p>{{ atividade.dataOperacao | date: "dd/MM/yyyy HH:mm" }}</p>
              </div>
              <div class="col">
                <p><b>Quanto tempo Duração da Atividade:</b></p>
                <div class="flex-horas">
                  <p>{{ atividade.tempoAtividade }} mn</p>
                </div>
              </div>
            </div>
            <div class="row-duas-colunas">
              <div class="col">
                <p><b>Tipo de atividade:</b></p>
                <p>{{ getTipoAtividade(atividade.tipoAtividade) }}</p>
              </div>
              <div class="col"></div>
            </div>
            <p>
              <b>Ação Realizada:</b><br />
              {{ atividade.descricaoAcaoRealizada }}
            </p>
            <p>
              <b>Próximos Passos:</b><br />
              {{ atividade.descricaoProximosPassos }}
            </p>

            <div class="conteudo-aprovacao">
              <p><b>Avaliação da Atividade:</b></p>
              <star-rating-conviva
                [rating]="atividade.estrelasAvaliacao ?? 0"
                [isReadOnly]="true"
              />
              <p *ngIf="atividade.descricaoJustificativaAvaliacao">
                <b>Justificativa:</b>
                {{ atividade.descricaoJustificativaAvaliacao }}
              </p>
            </div>

            <div class="conteudo-envolvido">
              @if (hasTipoPessoa(atividade, 1)) {
                <h4>Envolvido</h4>
                <div class="card-envolvido">
                  @for (
                    envolvido of atividade.envolvidos;
                    track envolvido.codigoEnvolvido
                  ) {
                    <div class="header-perfil-chamado perfil-aluno-envolvidos">
                      <div>
                        <a
                          href="javascript:void(0)"
                          class="card-chamado aberto"
                          aria-label="Visualizar histórico do envolvido"
                        >
                          <div class="perfil-aluno-chamado ativo">
                            <div class="perfil-aluno encaminhado">
                              <div class="img-aluno">
                                <span>{{ envolvido.iniciais }}</span>
                              </div>
                            </div>
                            <div class="infor-aluno-chamado">
                              <p class="nome-aluno">
                                {{ envolvido.nomeAluno }}
                              </p>
                              <!-- <p class="descricao">Aluno - Ofensor</p> -->
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  }
                </div>
              } @else if (hasTipoPessoa(atividade, 2)) {
                <h3>Convidados</h3>

                <div class="grid-datatable outros">
                  <app-tabulator-table
                    [tableData]="atividade.envolvidos"
                    [columnNames]="colunasGridEquipeEscolar"
                    [tableTitle]="'teste'"
                    [tipoRelatorio]="2"
                    [orientacaoPortrait]="false"
                    [mostrarFiltro]="false"
                  />
                </div>
              } @else if (hasTipoPessoa(atividade, 4)) {
                <h3>Turmas</h3>
                <div class="grid-datatable">
                  <app-tabulator-table
                    [tableData]="atividade.envolvidos"
                    [columnNames]="colunasGridTurma"
                    [tableTitle]="'teste'"
                    [tipoRelatorio]="2"
                    [orientacaoPortrait]="false"
                    [mostrarFiltro]="false"
                  />
                </div>
              } @else if (hasTipoPessoa(atividade, 3)) {
                <h3>Convidados</h3>

                <div class="grid-datatable outros">
                  <app-tabulator-table
                    [tableData]="atividade.envolvidos"
                    [columnNames]="colunasGridOutros"
                    [tableTitle]="'teste'"
                    [tipoRelatorio]="2"
                    [orientacaoPortrait]="false"
                    [mostrarFiltro]="false"
                  />
                  <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border"
              aria-describedby="dashboard">
              <thead>
                <tr>
                  <th>Equipe Escola e Outros</th>
                </tr>
              </thead>
              <tbody>
                @for (item of lstEquipeEscolar; track $index) {
                <tr>
                  <td>{{item}}</td>
                </tr>
                }
                @for (item of lstOutros; track $index) {
                <tr>
                  <td>{{item}}</td>
                </tr>
                }
              </tbody>
            </table> -->
                </div>
              }
            </div>

            <div
              class="grupo-filter-full"
              *ngIf="atividade.arquivos.length > 0"
            >
              <h3>Anexos</h3>
              <div class="imagem-escolhida">
                @for (
                  arquivo of atividade.arquivos;
                  track arquivo.codigoAtividade
                ) {
                  <app-card-arquivo-anexado
                    [arquivo]="getArquivoAzure(arquivo)"
                    [index]="$index"
                    [showRemoveButton]="false"
                    (visualizar)="visualizarAquivo($event, atividade)"
                    (download)="DownloadArquivo(getArquivoAzure(arquivo))"
                  ></app-card-arquivo-anexado>
                }
              </div>
            </div>
            <!-- <div class="conteudo-aprovacao">
            <p><b>Descreva justificativa da avaliação:</b></p>
            <star-rating-conviva />
          </div>

          <div class="grup_input">
            <label>Descreva justificativa da avaliação:</label>
            <textarea
            class="input-textarea"
            rows="3"
            placeholder="Descreva a justificativa da avaliação"
            aria-label="Descreva a justificativa da avaliação"
            ></textarea>
          </div>

          <div class="conteudo-btns">
            <input
              type="button"
              class="btn_outline"
              value="Limpar"
              [disabled]
            />
            <input
              type="submit"
              class="btn_primary"
              value="Salvar"
            />
          </div> -->
          </div>
        </details>

        <!-- Acordion de LOG -->
        @for (
          atividadeLog of atividade?.atividadeLog;
          track atividadeLog.CdAtividadeLog
        ) {
          <div class="acordion-log-recuado">
            <details>
              <summary>
                <span class="historico-label">Histórico</span>
              </summary>
              <div class="conteudo-detalhes-acordion">
                <div class="row-duas-colunas">
                  <div class="col">
                    <p><b>Usuário:</b></p>
                    <p>{{ atividadeLog.nmUsuarioAlter }}</p>
                  </div>
                  <div class="col">
                    <p><b>Data da Operação:</b></p>
                    <div class="flex-horas">
                      <p>{{ atividadeLog.dtOperacao }}</p>
                    </div>
                  </div>
                </div>
                <div class="row-duas-colunas">
                  <div class="col">
                    <p><b>Titulo:</b></p>
                    <p>{{ atividadeLog.titulo }}</p>
                  </div>
                  <div class="col"></div>
                </div>
                <p></p>
                <div class="row-duas-colunas">
                  <div class="col">
                    <p><b>Data da Visita:</b></p>
                    <p>{{ atividadeLog.dataAtividade | date: "dd/MM/yyyy" }}</p>
                    <!-- <p>01/07/2024</p> -->
                  </div>
                  <div class="col">
                    <p><b>Quanto tempo Duração da Atividade:</b></p>
                    <div class="flex-horas">
                      <p>{{ atividadeLog.tempoAtividade }} mn</p>
                    </div>
                  </div>
                </div>
                <div class="row-duas-colunas">
                  <div class="col">
                    <p><b>Tipo de atividade:</b></p>
                    <p>{{ getTipoAtividade(atividadeLog.tipoAtividade) }}</p>
                  </div>
                  <div class="col"></div>
                </div>
                <p>
                  <b>Ação Realizada:</b><br />
                  {{ atividadeLog.descricaoAcaoRealizada }}
                </p>
                <p>
                  <b>Próximos Passos:</b><br />
                  {{ atividadeLog.descricaoProximosPassos }}
                </p>
                <div class="conteudo-envolvido">
                  @if (hasTipoPessoa(atividadeLog, 1)) {
                    <h4>Envolvido</h4>
                    <div class="card-envolvido">
                      @for (
                        envolvido of atividadeLog.envolvidos;
                        track envolvido.codigoEnvolvido
                      ) {
                        <div
                          class="header-perfil-chamado perfil-aluno-envolvidos"
                        >
                          <div>
                            <a
                              href="javascript:void(0)"
                              class="card-chamado aberto"
                              aria-label="Visualizar histórico do envolvido"
                            >
                              <div class="perfil-aluno-chamado ativo">
                                <div class="perfil-aluno encaminhado">
                                  <div class="img-aluno">
                                    <span>{{ envolvido.iniciais }}</span>
                                  </div>
                                </div>
                                <div class="infor-aluno-chamado">
                                  <p class="nome-aluno">
                                    {{ envolvido.nomeAluno }}
                                  </p>
                                  <!-- <p class="descricao">Aluno - Ofensor</p> -->
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      }
                    </div>
                  } @else if (hasTipoPessoa(atividadeLog, 2)) {
                    <h3>Convidados</h3>

                    <div class="grid-datatable outros">
                      <app-tabulator-table
                        [tableData]="atividadeLog.envolvidos || []"
                        [columnNames]="colunasGridEquipeEscolar"
                        [tableTitle]="'teste'"
                        [tipoRelatorio]="2"
                        [orientacaoPortrait]="false"
                        [mostrarFiltro]="false"
                      />
                    </div>
                  } @else if (hasTipoPessoa(atividadeLog, 4)) {
                    <h3>Turmas</h3>
                    <div class="grid-datatable">
                      <app-tabulator-table
                        [tableData]="atividadeLog.envolvidos || []"
                        [columnNames]="colunasGridTurma"
                        [tableTitle]="'teste'"
                        [tipoRelatorio]="2"
                        [orientacaoPortrait]="false"
                        [mostrarFiltro]="false"
                      />
                    </div>
                  } @else if (hasTipoPessoa(atividadeLog, 3)) {
                    <h3>Convidados</h3>

                    <div class="grid-datatable outros">
                      <app-tabulator-table
                        [tableData]="atividadeLog.envolvidos || []"
                        [columnNames]="colunasGridOutros"
                        [tableTitle]="'teste'"
                        [tipoRelatorio]="2"
                        [orientacaoPortrait]="false"
                        [mostrarFiltro]="false"
                      />
                    </div>
                  }
                </div>
                <div
                  class="grupo-filter-full"
                  *ngIf="atividadeLog.arquivos.length > 0"
                >
                  <h3>Anexos</h3>
                  <div class="imagem-escolhida">
                    @for (
                      arquivo of atividadeLog.arquivos;
                      track arquivo.codigoAtividade
                    ) {
                      <app-card-arquivo-anexado
                        [arquivo]="getArquivoAzure(arquivo)"
                        [index]="$index"
                        [showRemoveButton]="false"
                        (visualizar)="visualizarAquivo($event, atividadeLog)"
                        (download)="DownloadArquivo(getArquivoAzure(arquivo))"
                      ></app-card-arquivo-anexado>
                    }
                  </div>
                </div>
              </div>
            </details>
          </div>
          <!-- Acordion de LOG fim -->
        }
      }
      <!-- open -->
    </div>
  </div>
</section>

<!-- Modal Visualizar Arquivo -->
<app-modal *ngIf="showModalVisualizarArquivo && arquivoVisualizando">
  <app-visualizar-arquivo
    [arquivo]="arquivoVisualizando"
    (fechar)="fecharModalVisualizarArquivo()"
  ></app-visualizar-arquivo>
</app-modal>

<!--
     <details open>
        <summary>Mussum Ipsum</summary>
        <div class="conteudo-detalhes-acordion">
          <div class="row-duas-colunas">
            <div class="col">
             <p><b>Data da Visita:</b></p>
             <p>01/07/2024</p>
            </div>
            <div class="col">
             <p><b>Quanto tempo Duração da Atividade:</b></p>
             <p>60 mn</p>
            </div>
          </div>
          <div class="row-duas-colunas">
            <div class="col">
             <p><b>Tipo de atividade:</b></p>
             <p>Acolhimento</p>
            </div>
            <div class="col">
            </div>
          </div>
          <p>
            <b>Ação Realizada:</b><br />
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam odio molestiae consectetur assumenda temporibus, nisi aliquam distinctio odit voluptatem, ducimus eius repellendus, iure ex maxime quam tempora delectus veritatis dignissimos?
          </p>
          <p>
            <b>Ação Realizada:</b><br />
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam odio molestiae consectetur assumenda temporibus, nisi aliquam distinctio odit voluptatem, ducimus eius repellendus, iure ex maxime quam tempora delectus veritatis dignissimos?
          </p>

          <div class="conteudo-envolvidos">
            <h4>Envolvido</h4>

            <div class="header-perfil-chamado perfil-aluno-envolvidos">
            <div>
                  <a
                  href="javascript:void(0)"
                  class="card-chamado aberto"
                  aria-label="Visualizar histórico do envolvido"
                  >
                    ativo
                    <div class="perfil-aluno-chamado ativo">
                      <div class="perfil-aluno encaminhado">
                        <div class="img-aluno">
                          <span>JP</span>
                        </div>
                      </div>
                      <div class="infor-aluno-chamado">
                        <p class="nome-aluno">José Pereira</p>
                        <p class="descricao">Aluno - Ofensor</p>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
          </div>

          <div class="conteudo-aprovacao">
            <p><b>Descreva justificativa da avaliação:</b></p>
            <star-rating-conviva />
          </div>

          <div class="grup_input">
            <label>Descreva justificativa da avaliação:</label>
            <textarea
            class="input-textarea"
            rows="3"
            placeholder="Descreva a justificativa da avaliação"
            aria-label="Descreva a justificativa da avaliação"
            ></textarea>
          </div>

          <div class="conteudo-btns">
            <input
              type="button"
              class="btn_outline"
              value="Limpar"
              [disabled]
            />
            <input
              type="submit"
              class="btn_primary"
              value="Salvar"
            />
          </div>

        </div>
      </details>

      class="atividade-salva"
     <details >
        <summary>Mussum Ipsum</summary>
        <div class="conteudo-detalhes-acordion">
          <div class="row-duas-colunas">
            <div class="col">
             <p><b>Data da Visita:</b></p>
             <p>01/07/2024</p>
            </div>
            <div class="col">
             <p><b>Quanto tempo Duração da Atividade:</b></p>
             <p>60 mn</p>
            </div>
          </div>
          <div class="row-duas-colunas">
            <div class="col">
             <p><b>Tipo de atividade:</b></p>
             <p>Acolhimento</p>
            </div>
            <div class="col">
            </div>
          </div>
          <p>
            <b>Ação Realizada:</b><br />
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam odio molestiae consectetur assumenda temporibus, nisi aliquam distinctio odit voluptatem, ducimus eius repellendus, iure ex maxime quam tempora delectus veritatis dignissimos?
          </p>
          <p>
            <b>Ação Realizada:</b><br />
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam odio molestiae consectetur assumenda temporibus, nisi aliquam distinctio odit voluptatem, ducimus eius repellendus, iure ex maxime quam tempora delectus veritatis dignissimos?
          </p>

          <div class="conteudo-envolvidos">
            <h4>Envolvido</h4>
          </div>

          <div class="conteudo-aprovacao">
            <p><b>Descreva justificativa da avaliação:</b></p>
            <star-rating-conviva />
          </div>

          <div class="grup_input">
            <label>Descreva justificativa da avaliação:</label>
            <textarea
            class="input-textarea"
            rows="3"
            placeholder="Descreva a justificativa da avaliação"
            aria-label="Descreva a justificativa da avaliação"
            ></textarea>
          </div>

          <div class="conteudo-btns">
            <input
              type="button"
              class="btn_outline"
              value="Limpar"
            />
            <input
              type="submit"
              class="btn_primary"
              value="Salvar"
            />
          </div>

        </div>
      </details>

      <details>
        <summary>Mussum Ipsum</summary>
        <div class="conteudo-detalhes-acordion">
          <div class="row-duas-colunas">
            <div class="col">
             <p><b>Data da Visita:</b></p>
             <p>01/07/2024</p>
            </div>
            <div class="col">
             <p><b>Quanto tempo Duração da Atividade:</b></p>
             <p>60 mn</p>
            </div>
          </div>
          <div class="row-duas-colunas">
            <div class="col">
             <p><b>Tipo de atividade:</b></p>
             <p>Acolhimento</p>
            </div>
            <div class="col">
            </div>
          </div>
          <p>
            <b>Ação Realizada:</b><br />
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam odio molestiae consectetur assumenda temporibus, nisi aliquam distinctio odit voluptatem, ducimus eius repellendus, iure ex maxime quam tempora delectus veritatis dignissimos?
          </p>
          <p>
            <b>Ação Realizada:</b><br />
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam odio molestiae consectetur assumenda temporibus, nisi aliquam distinctio odit voluptatem, ducimus eius repellendus, iure ex maxime quam tempora delectus veritatis dignissimos?
          </p>

          <div class="conteudo-envolvidos">
            <h4>Envolvido</h4>
          </div>

          <div class="conteudo-aprovacao">
            <p><b>Descreva justificativa da avaliação:</b></p>
            <star-rating-conviva />
          </div>

          <div class="grup_input">
            <label>Descreva justificativa da avaliação:</label>
            <textarea
            class="input-textarea"
            rows="3"
            placeholder="Descreva a justificativa da avaliação"
            aria-label="Descreva a justificativa da avaliação"
            ></textarea>
          </div>

          <div class="conteudo-btns">
            <input
              type="button"
              class="btn_outline"
              value="Limpar"
            />
            <input
              type="submit"
              class="btn_primary"
              value="Salvar"
            />
          </div>

        </div>
      </details> -->
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
